import { useBasketProviderData } from '../hooks';
export const BasketProvider = () => {
  useBasketProviderData();
  return null;
};
//# sourceMappingURL=BasketProvider.js.map